export default "__VITE_ASSET__D15hlBA9__"